import Length from '../../../../source/js/shared/models/Geometry/Length';
import { MaximumDecimalPoints } from "@/Models/Validators/MaximumDecimalPoints";
import { MinimumValue } from "@/Models/Validators/MinimumValue";
import { MaximumValue } from "@/Models/Validators/MaximumValue";
import { ShapeConfigurationInterface } from './ShapeConfigurationInterface';
import Rectangle from "../../../../source/js/shared/models/Geometry/Rectangle";
import { ShapeCategory } from '@/types/shapeCategories';
import AbstractShape, { Dimensions } from '../Shapes/AbstractShape';
import { ValidatorInterface } from '../Validators/ValidatorInterface';
import { OrValidator } from '../Validators/OrValidator';

export default class DropletConfiguration implements ShapeConfigurationInterface {
	public hasNewValidators = true;

	get_dimension_keys(): string[] {
		return [
			'height',
			'width',
		];
	}

	get_modifier_keys(): string[] {
		return [];
	}

	get_maximum_dimensions( maximum_rectangle: Rectangle ): Record<string, Length> {
		return {
			height: maximum_rectangle.get_longest_side(),
			width: maximum_rectangle.get_shortest_side(),
		};
	}

	get_maximum_variable_dimensions( dimensions: Dimensions ): Record<string, Length> {
		const maxWidth = dimensions.height - 1;
		return {
			width: Length.from_cm(maxWidth),
		};
	}

	get_minimum_dimensions( minimum: number, dimensions: Dimensions ): Record<string, Length>|null {
		return {
			height: Length.from_cm(dimensions.width + 1),
			width: Length.from_cm(minimum),
		};
	}

	get_validators(): Record<string, Array<unknown>> {
		return {
			height: [ MaximumDecimalPoints, MinimumValue, MaximumValue ],
			width: [ MaximumDecimalPoints, MinimumValue, MaximumValue ],
		};
	}

	get_new_validators( instance: AbstractShape, minimum: number, maximums: Record<string, Length>, dimensions: Dimensions ): ValidatorInterface[] {
		const minHeight = dimensions.width + 1;
		const maxWidth = dimensions.height - 1;

		return [
			new OrValidator([
				new MaximumValue( {
					field: 'droplet-width',
					dimension: 'width',
					instance,
					maximums: {
						width: Length.from_cm(maxWidth),
						height: maximums.height
					},
				} ),
				new MinimumValue( {
					field: 'droplet-height',
					dimension: 'height',
					minimums: {
						height: Length.from_cm(minHeight),
					},
					instance,
				} ),
			]),
			new MaximumDecimalPoints( {
				field: 'droplet-height',
				dimension: 'height',
				decimalPoints: 1,
				instance,
			} ),
			new MaximumDecimalPoints( {
				field: 'droplet-width',
				dimension: 'width',
				decimalPoints: 1,
				instance,
			} ),
			new MaximumValue( {
				field: 'droplet-width',
				dimension: 'width',
				instance,
				maximums,
			} ),
			new MinimumValue( {
				field: 'droplet-width',
				dimension: 'width',
				minimum,
				instance,
			} ),
			new MinimumValue( {
				field: 'droplet-height',
				dimension: 'height',
				minimum,
				instance,
			} ),
			new MaximumValue( {
				field: 'droplet-height',
				dimension: 'height',
				instance,
				maximums,
			} )
		];
	}

	get_cutout_validators( instance: AbstractShape, dimensions: Dimensions ): ValidatorInterface[] {
		const minHeight = dimensions.width + 1;
		const maxWidth = dimensions.height - 1;

		return [
			new OrValidator([
				new MaximumValue( {
					field: 'droplet-width',
					dimension: 'width',
					instance,
					maximums: {
						width: Length.from_cm(maxWidth),
					},
				} ),
				new MinimumValue( {
					field: 'droplet-height',
					dimension: 'height',
					minimums: {
						height: Length.from_cm(minHeight),
					},
					instance,
				} ),
			]),
			new MaximumValue( {
				field: 'droplet-width',
				dimension: 'width',
				instance,
				maximums: {
					width: Length.from_cm(maxWidth),
				},
			} ),
		];
	}

	get_category(): ShapeCategory {
		return 'complex';
	}
}
